// src/layouts/Layout.js - Versión modular que importa Sidebar y Navbar
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Importar componentes modulares
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

/**
 * Layout principal del panel de administración.
 * Este componente modular importa y utiliza Sidebar y Navbar por separado.
 */
function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // El sidebar carga contraído por defecto (false) en todo tipo de dispositivos

  // Verificar autenticación al cargar el layout
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!user && !loading && !token) {
      console.log('Layout: Usuario no autenticado y sin token, redirigiendo a login');
      navigate('/login', { replace: true });
    }
  }, [user, loading, navigate]);

  // Manejar toggle del sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Manejar errores de renderizado en el contenido
  const renderContent = () => {
    try {
      return children || <div className="p-6">Seleccione una opción del menú</div>;
    } catch (error) {
      console.error("Error al renderizar contenido:", error);
      return (
        <div className="p-6 bg-red-50 border border-red-200 rounded">
          <h2 className="text-xl font-semibold text-red-700">Error al cargar el contenido</h2>
          <p className="text-red-600">Ha ocurrido un error al renderizar esta página.</p>
          <pre className="mt-2 p-2 bg-red-100 rounded text-sm overflow-auto">
            {error.message}
          </pre>
        </div>
      );
    }
  };

  // Mostrar pantalla de carga mientras se verifica autenticación
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-3">Cargando panel administrativo...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar como componente independiente */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} onOpen={() => setSidebarOpen(true)} />

      {/* Contenido principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Navbar como componente independiente */}
        <Navbar onMenuClick={toggleSidebar} />

        {/* Contenido principal con manejo de errores */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-3 sm:p-4 md:p-6">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}

export default Layout;